import { AvatarWithDetails, Group, Text } from '@melio/penny';
import { UserDetails } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';

type Props = {
  markedAsPayBy?: UserDetails;
  scheduledDate: Date;
};

export const MarkedAsPaidSection = ({ markedAsPayBy, scheduledDate }: Props) => {
  const { formatMessage, formatDate } = useMelioIntl();

  return (
    <Group variant="vertical" width="full" spacing="m" data-testid="marked-as-pay-section">
      <Text textStyle="body4SemiUpper" color="neutral.darker">
        {formatMessage('widgets.paymentDetails.markedAsPay.title')}
      </Text>
      <AvatarWithDetails
        avatarProps={{
          name:
            markedAsPayBy?.firstName && markedAsPayBy.lastName
              ? `${markedAsPayBy.firstName} ${markedAsPayBy.lastName}`
              : '',
        }}
        description={formatMessage('widgets.paymentDetails.markedAsPay.subtitle', {
          scheduledDate: formatDate(scheduledDate, { dateStyle: 'medium' }),
        })}
        mainLabelProps={{
          label: formatMessage('widgets.paymentDetails.markedAsPay.name', {
            lastName: markedAsPayBy?.lastName ?? '',
            firstName: markedAsPayBy?.firstName ?? '',
          }),
          'data-testid': 'marked-as-pay-section-user-name',
        }}
      />
    </Group>
  );
};
